import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex min-h-screen flex-1 flex-col justify-center py-12 sm:px-6 lg:px-8 bg-gray-50 dark:bg-gray-900" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "hidden w-full h-full absolute top-0 left-0 bg-black/10 z-0 dark:block" }, null, -1)
const _hoisted_3 = { class: "flex justify-items-center mt-10 mx-auto sm:w-full sm:max-w-[700px] z-10" }
const _hoisted_4 = { class: "bg-white px-6 pt-12 pb-10 shadow sm:rounded-lg sm:px-12 sign-in-card dark:bg-gray-900 dark:border dark:border-white/5 min-w-fit md:min-w-[37.5rem]" }

import {
		useRoute,
		useRouter
	} from 'vue-router'

	import { 
		store as _userStore
	} from '@/store/user'

	import { 
		store as _jobStore
	} from '@/store/job'

	// vue
	import {
		onBeforeMount
	} from 'vue'
	import PageFooter from "@/components/PageFooter.vue"

	
	const __default__ = { name: 'SimpleCard' } // name the component

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

	// router
	const route = useRoute()
	const router = useRouter()

	const userStore = _userStore()
	const jobStore = _jobStore()

	onBeforeMount(async () => {
		try {
			// check for sign out
			if(route.name === "SignOut") {
				jobStore.job.loggedIn = false
				router.push({name: "Login"})
			}
			// check for existing signing & reroute
			if(jobStore.job.loggedIn && route.name !== "SongSubmit") {
				router.push({name: "Search"})
			}
		}
		catch(e) {
			console.error(e)
		}
	})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "default")
        ])
      ])
    ]),
    _createVNode(PageFooter, { class: "flex flex-col" })
  ], 64))
}
}

})